import React, { createRef, Fragment, useEffect, useState } from "react";
import "../../assets/css/sap-master/sap-master.css";
import MainTable from "../components/main-tables";
import CancelIcon from "@mui/icons-material/Cancel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchIcon from "@mui/icons-material/Search";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import { useSelector } from "react-redux";
import {
  Autocomplete,
  Button,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
} from "@mui/material";
import {
  branch_master_is_first,
  list_branch_master,
} from "../../redux/prefered-master/list-branch-master";
import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import TextFiealdInput from "../components/textFiald";
import {
  add_branch_master,
  add_branch_isSuccess,
  add_branch_master_api_complete,
} from "../../redux/prefered-master/add-branch-master";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  addGroupDataData,
  clearGroupDataData,
} from "../../redux/sap-master/group-master-active-data-reducer";
import {
  edit_branch_isSuccess,
  edit_branch_master,
  edit_branch_master_api_complete,
} from "../../redux/prefered-master/edit-branch-master";
import CompletePopup from "../components/response-pop-up";
import { configs } from "../../common";
import { useCommonContext } from "../../Utils/commonContext";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

const BranchMaster = () => {
  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = useState<string>("");

  const dispatch = useDispatch();
  const [activePartner, setActivePartner] = React.useState<null | number>(0);
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [responseEdit, setResponseEdit] = useState<boolean>(false);
  const [isEdit, setEdit] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const editBranchMaster = useSelector((state: any) => state.EditBranchMaster);
  const activeDatas = useSelector((state: any) => state.GroupMasterActiveData);
  const activeData = activeDatas.data;
  const branch_master_data = useSelector(
    (state: any) => state.ListBranchMaster
  );
  const add_branch_master_data = useSelector(
    (state: any) => state.AddBranchMaster
  );
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };

  //   validation
  const validationSchema = Yup.object().shape({
    branch_code: Yup.string().required("Branch Code Is Required"),
    branch_name: Yup.string().required("Branch name Is Required"),
    sap_branch_code: Yup.string().required("Sap Branch Code Is Required"),
    branch_logo: Yup.mixed()
      .test(
        "fileFormat",
        "Unsupported Format - We only allow images.",
        (value) => {
          if (value) {
            SUPPORTED_FORMATS.includes(value.type);
          }
          return true;
        }
      )
      .required("branch logo is required")
      .nullable(),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      branch_code: isEdit ? editData.branch_code : "",
      branch_name: isEdit ? editData.branch_name : "",
      sap_branch_code: isEdit ? editData.sap_branch_code : "",
      active: isEdit ? editData.active : true,
      branch_logo: isEdit
        ? editData.branch_logo
        : {
            name: "",
          },
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
  } = formik;

  const submit = (a: any) => {
    if (!isEdit) {
      const formData = new FormData();
      formData.append("branch_code", a.branch_code);
      formData.append("branch_name", a.branch_name);
      formData.append("active", a.active);
      formData.append("sap_branch_code", a.sap_branch_code);
      formData.append("branch_logo", a.branch_logo);
      dispatch(add_branch_master(formData));
    } else {
      const formData = new FormData();
      formData.append("id", activeData.id);
      formData.append("branch_code", a.branch_code);
      formData.append("active", a.active);
      formData.append("branch_name", a.branch_name);
      formData.append("sap_branch_code", a.sap_branch_code);
      formData.append("branch_logo", a.branch_logo);
      dispatch(edit_branch_master(formData));
      // for (var pair of formData.enttrueries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }
    }
  };
  // useEffect
  useEffect(() => {
    dispatch(list_branch_master(""));
    if (add_branch_master_data.isSuccess) {
      dispatch(add_branch_isSuccess(""));
      setOpen(false);
      resetForm();
    }
    if (editBranchMaster.isSuccess) {
      dispatch(edit_branch_isSuccess(""));
      setOpen(false);
      setEdit(false);
      resetForm();
    }
    if (add_branch_master_data.api_completed) {
      setResponsePopup(true);
      dispatch(add_branch_master_api_complete(false));
    }
    if (editBranchMaster.api_completed) {
      setResponseEdit(true);
      dispatch(edit_branch_master_api_complete(false));
      setResponsePopup(true);
    }
  }, [add_branch_master_data, editBranchMaster]);
  const fileRep = createRef<any>();

  const handleBack = () => {
    dispatch(clearGroupDataData());
    setShowBack(false);
    setTitleContext("Branch Master");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearGroupDataData());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.branch_name) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.branch_name ?? "Branch Master");
  }, [activeData]);

  // mainTable data
  const mainTable = () => {
    const filterarr = [];
    for (let i = 0; i < branch_master_data.data.result.length; i++) {
      let data = { ...branch_master_data.data.result[i] };
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // create on
      const created_on = new Date(data.created_on);
      // delete data.EffecDate;
      const created_date =
        created_on.getDate() +
        "-" +
        monthNames[created_on.getMonth()] +
        "-" +
        created_on.getFullYear();
      data.created_on
        ? (data.created_on = created_date)
        : console.log("sdfdsf");

      // update on
      const updated_on = new Date(data.updated_on);
      data.branch_logo = data.branch_logo ? (
        <img
          style={{
            maxHeight: "50px",
            maxWidth: "200px",
          }}
          src={configs.api + "/" + data.branch_logo}
          alt="branch logo"
        />
      ) : (
        "-"
      );
      // delete data.EffecDate;
      const update_date =
        updated_on.getDate() +
        "-" +
        monthNames[updated_on.getMonth()] +
        "-" +
        updated_on.getFullYear();
      data.updated_on ? (data.updated_on = update_date) : console.log("sdfdsf");

      filterarr.push(data);
    }
    // filterarr.filter((e) => delete e.id);
    // filterarr.filter((e) => delete e.active);
    // filterarr.filter((e) => delete e.created_by);
    // filterarr.filter((e) => delete e.updated_by);
    console.log(branch_master_data);
    return (
      <Fragment>
        <div className="content_container">
          <div
            className={`mini_side_container`}
            style={{
              display: isMobile && activeData.id ? "none" : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              Branch Master
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(list_branch_master(""));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>

              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  handleClickOpen();
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "add"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {filterarr
                .filter((item: any) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((e: any, key: number) => {
                  if (branch_master_data.isFirst && key === 0) {
                    dispatch(branch_master_is_first(""));
                  }
                  return (
                    <div
                      key={key + 1}
                      onClick={(a) => {
                        setActivePartner(key);
                        dispatch(addGroupDataData(e));
                      }}
                      className={`side_content_card`}
                    >
                      <div
                        className={`side_content_mini_card ${
                          e.id === activeData.id ? "active" : ""
                        }`}
                      >
                        <div className="f4 title">{e.branch_name}</div>
                        <div className="side_content_footer">
                          <h4 className="f4 subtitle">{e.branch_code}</h4>
                          {/* <h4>{e.status}</h4> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display: isMobile && !activeData.id ? "none" : "initial",
            }}
          >
            {Object.keys(activeData).length === 0 ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One Branch
              </div>
            ) : (
              <Fragment>
                <div className="content_header justify-content-end">
                  <div className="btns">
                    <Button
                      className="common_btn_outline"
                      disableRipple
                      onClick={() => {
                        setEdit(true);
                        setEditData(activeData);
                        handleClickOpen();
                      }}
                    >
                      Edit
                      <FontAwesomeIcon
                        icon="edit"
                        title="Edit partner onboarding"
                      />
                    </Button>
                  </div>
                </div>

                <div className="scroll_content_container scroll_content_container_2">
                  <div className="grid_container">
                    <div className="detail_item">
                      <label className="f4">Branch Name</label>
                      <p>{activeData.branch_name}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Branch Code</label>
                      <p>{activeData.branch_code}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">SAP Branch Code</label>
                      <p>{activeData.sap_branch_code}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Branch Logo</label>
                      <p>{activeData.branch_logo}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Active</label>
                      <p>{activeData.active ? "Active" : "InActive"}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Create On</label>
                      <p>{activeData.created_on}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Update On</label>
                      <p>{activeData.updated_on}</p>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <div className="partner-details">
        {responsePopup ? (
          <CompletePopup
            data={responseEdit ? editBranchMaster : add_branch_master_data}
            responsePopup={responsePopup}
            setCompletePopup={(e: any) => {
              setResponsePopup(false);
              setResponseEdit(false);
            }}
          />
        ) : (
          ""
        )}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={branch_master_data.isLoading ? true : false}
        >
          {/* <CircularProgress color="inherit" /> */}
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
        {/* <div className="title d-flex">
          <h5>Branch Master</h5>
          
        </div> */}
        {branch_master_data.isSuccess && mainTable()}
      </div>
      {/* add from */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="dialog_header common_border_bottom">
          <h4 id="alert-dialog-title" className="f4">
            {"Add Branch"}
          </h4>

          <CancelIcon
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <DialogContent>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="branch_code"
                label="Branch Code"
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="branch_name"
                label="Branch Name"
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="sap_branch_code"
                label="Sap Branch Code"
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="field_item">
                <label className="f4">Branch Logo</label>
                <div
                  className={`${
                    errors.branch_logo && touched.branch_logo
                      ? "msme-certificate-require"
                      : "msme-certificate"
                  } attachment_mention`}
                  onClick={() => {
                    fileRep.current.click();
                    console.log("DSF");
                  }}
                >
                  <FontAwesomeIcon
                    className="ms-50"
                    icon={["fas", "paperclip"]}
                    style={{
                      fontSize: "1vw",
                      marginLeft: "10px",
                      marginRight: "10px",
                      color: "#908f8f",
                    }}
                  />
                  <label>
                    {values.branch_logo.name === ""
                      ? "Upload branch logo"
                      : values.branch_logo.name}
                  </label>
                </div>
                <span
                  className={`${
                    errors.branch_logo && touched.branch_logo
                      ? "text-danger"
                      : ""
                  } attachment_mention`}
                >
                  Supported file(.jpeg,.jpg,.png)
                </span>
                <TextField
                  inputRef={fileRep}
                  type="file"
                  // value={values.msme_certificate}
                  name="branch_logo"
                  onChange={(e: any) => {
                    setFieldValue("branch_logo", e.target.files[0]);
                    setFieldTouched("branch_logo", true, false);
                  }}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": {
                      top: 0,
                      border: "2px solid #c4c4c4",
                      borderRadius: "0px",
                    },
                    // borderRadius: "0px",
                    fontWeight: "700",
                    fontFamily: "Roboto",
                    display: "none",
                  }}
                  inputProps={{
                    style: {
                      height: "20px",
                    },
                  }}
                />
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="field_item">
                <FormControlLabel
                  value={values.active}
                  control={<Checkbox checked={values.active} />}
                  label="Is Active"
                  onChange={handleChange}
                  name="active"
                  labelPlacement="end"
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div className="dialog_footer">
            <Button
              disableRipple
              className="common_btn_outline"
              onClick={() => {
                handleClose();
                setEdit(false);
              }}
            >
              Cancel
            </Button>
            <Button
              className="common_btn"
              disableRipple
              onClick={() => {
                handleSubmit();
              }}
            >
              {add_branch_master_data.isLoading ? "Please Wait..." : "Save"}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default BranchMaster;
